import { TDynamicVariable } from "@shared/types";
import {
  TMinimumProductConfig,
  TMinimumShape,
  CoreConfig,
  MinimumOption,
  TMinimumOptionList,
} from "../types";
import { usesParentValue } from "../utils";
const computeOptionValue = (
  option: MinimumOption | undefined,
  config: CoreConfig
) => {
  if (!option) return undefined;
  // Some data is invalid
  // @ts-ignore
  if (option.variabletype && !option.variableType) {
    // @ts-ignore
    option.variableType = option.variabletype;
  }
  if (!["number", "text"].includes(option.variableType || "none")) {
    return option.name;
  }
  const OptionList = config.ProductConfiguration?.OptionsList.find((ol) => {
    return ol?.options?.includes(option._id);
  });
  switch (option.variableType) {
    case "number":
      return `${OptionList?.number || 0}${option.unit || ""}`;
    case "text":
      return `${OptionList?.text || ""}`;
  }
  return option.name;
};
export const calculateSubcategory = (
  variable: TDynamicVariable,
  config: CoreConfig,
  debug = false
): string | 1 | 0 | null | undefined => {
  if (
    (variable.categoryId && usesParentValue(variable.categoryId, config)) ||
    /^PARENT/.test(variable.variableType)
  ) {
    const { parent, ...rest } = config;
    return calculateSubcategory(
      { ...variable, variableType: "SUBCATEGORY" },
      {
        ...rest,
        ...parent,
      },
      debug
    );
  }
  const subCategory = (config.ProductConfiguration?.OptionsList || []).find(
    (sl) => sl.SubCategory?._id === variable.subcategoryId
  );

  switch (variable.output) {
    default:
    case "EXISTS":
      return subCategory ? 1 : 0;
    case "VALUE":
      if (!subCategory) {
        return null;
      }
      const options = subCategory.options?.map((o) =>
        computeOptionValue(
          subCategory?.SubCategory?.Options?.find((oo) => oo._id === o),
          config
        )
      );
      return options?.join(",");
  }
};

export const calculateStaticSubcategory = (
  variable: TDynamicVariable,
  config: CoreConfig,
  debug = false
): string | 1 | 0 | null | undefined => {
  if (
    (variable.categoryId && usesParentValue(variable.categoryId, config)) ||
    /^PARENT/.test(variable.variableType)
  ) {
    const { parent, ...rest } = config;
    return calculateStaticSubcategory(
      { ...variable, variableType: "STATIC_SUBCATEGORY" },
      {
        ...rest,
        ...parent,
      },
      debug
    );
  }
  if( variable?.Option?.name ){
    return variable?.Option?.name;
  }
  let subCategory = [...(config.ProductConfiguration?.OptionsList || [])  ].find(
    (sl) =>
      sl.SubCategory?._id === variable.subcategoryValueId ||
      sl.SubCategory?._id === variable.subcategoryId
  )?.SubCategory;
  if( !subCategory ){
    const c : any = (config.ProductConfiguration?.Product?.Categories as any )?.reduce( (pv : any , cv : any   ) => {
      return [...(cv?.SubCategorys || [] ), ...pv ];
    }  , [] )  as any;
    subCategory = c.find( (sc : any ) => sc._id === variable.subcategoryValueId || sc._id === variable.subcategoryId ) ;
  }
  if (debug) {
    console.log("calculateStaticSubcategory", subCategory, variable);
  }
  switch (variable.output) {
    default:
    case "EXISTS":
      return subCategory ? 1 : 0;
    case "VALUE":
      if (!subCategory) {
        return null;
      }
      const value = subCategory?.Options?.find(
        (o) => o._id === variable.optionId
      );
      return value?.name ;
  }
};
